jQuery('#menu_button_cover').on('click', function() {
  jQuery('.menu-background').addClass('open');
  jQuery('body').css('overflow','hidden');
  setTimeout(function(){
    jQuery('.menu-content').addClass('open');
  }, 500);
});

jQuery('.close-menu').on('click', function() {
  jQuery('.menu-content').removeClass('open');
  jQuery('.menu-background').removeClass('open');
  jQuery('body').css('overflow','visible');
});

jQuery('.menu-primary-menu-container li.contact-link').on('click', function(){
  jQuery('.menu-content').removeClass('open');
  jQuery('.menu-background').removeClass('open');
  jQuery('.sideform-color').addClass('show');
  setTimeout(function(){
    jQuery('.sideform-content').addClass('show');
  }, 500);
});

jQuery(window).on('scroll resize', function() {
  if (jQuery(document).scrollTop() > 5) {
    jQuery('header').addClass('scroll');
  }
  else {
    jQuery('header').removeClass('scroll');
  }
});

var container = document.getElementsByClassName('menu-content')[0];
document.addEventListener('click', function( event ) {
  if (container !== event.target && !container.contains(event.target)) {
    if(container.classList.contains('open')) {
      jQuery('.menu-content').removeClass('open');
      jQuery('.menu-background').removeClass('open');
      jQuery('body').css('overflow','visible');
    }
  }
});

document.addEventListener("DOMContentLoaded", function() {
  const topHeader = document.querySelector('.top-header');
  const scrollingText = document.querySelector('.scrolling-text');

  if (topHeader && scrollingText) {
    if (scrollingText.scrollWidth > topHeader.clientWidth) {
      topHeader.classList.add('scrolling');
    } else {
      topHeader.classList.remove('scrolling');
    }
  }
});

document.addEventListener("DOMContentLoaded", function() {
  const phoneLink = document.querySelector('a[href="tel:01603859007"]');
  const emailLink = document.querySelector('a[href="mailto:hello@nuimage.co.uk"]');

  if (phoneLink) {
    phoneLink.addEventListener('click', function() {
      if (typeof AnalyticsWP !== 'undefined' && typeof AnalyticsWP.event === 'function') {
        // Track the event using AnalyticsWP
        AnalyticsWP.event('phone_click', {
          unique_event_identifier: 'phone_click_01603859007',
          phone_number: '01603859007',
          aria_label: 'Call us'
        });
      }
    });
  }

  if (emailLink) {
    emailLink.addEventListener('click', function() {
      if (typeof AnalyticsWP !== 'undefined' && typeof AnalyticsWP.event === 'function') {
        // Track the event using AnalyticsWP
        AnalyticsWP.event('email_click', {
          unique_event_identifier: 'email_click_hello@nuimage.co.uk',
          email_address: 'hello@nuimage.co.uk',
          aria_label: 'Email us'
        });
      }
    });
  }
});